/**
 * Configuration file for Topup History component
 * Contains table columns, filter options, and other component configurations
 */

/**
 * Table column configuration for topup history
 */
export const columnConfig = [
  {
    key: 'created_at',
    label: 'Tanggal Transaksi',
  },
  {
    key: 'account_number',
    label: 'Nomor Virtual Account',
  },
  {
    key: 'amount',
    label: 'Nominal',
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: '#333333',
      minWidth: '120px',
      textAlign: 'center',
      fontWeight: 400,
    },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'center',
    },
    tdClass: 'text-center',
  },
]
/**
 * Status styling configuration
 */
export const statusStyles = {
  PENDING: {
    class: 'bg-[#D9E7FD] text-[#376FCB] border-[1px] border-[#4285F4]',
    text: 'Pending',
  },
  COMPLETED: {
    class: 'bg-[#DCF3EB] text-[#10673E] border-[1px] border-[#34A770]',
    text: 'Berhasil',
  },
  FAILED: {
    class: 'bg-[#FFE9E9] text-[#E31A1A] border-[1px] border-[#E31A1A]',
    text: 'Gagal',
  },
}
